module.exports = __webpack_public_path__ + "img/yt.5a0d14cf.png";